import React from 'react';
import './TextInput.css';
import {Input} from "../Input/Input";

export const TextInput = (options) => {
  return (<Input type="text" {...options} />);
};